/**
 * Route for `third-party-fraud-integrations-mfilterit-fraudscor`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ThirdPartyFraudIntegrationsMfilteritFraudscorPage } from "../features/third-party-fraud-integrations-mfilterit-fraudscor/ThirdPartyFraudIntegrationsMfilteritFraudscorPage";

export const thirdPartyFraudIntegrationsMfilteritFraudscorRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/third-party-fraud-integrations-mfilterit-fraudscor",
	component: ThirdPartyFraudIntegrationsMfilteritFraudscorPage,
});

export default thirdPartyFraudIntegrationsMfilteritFraudscorRoute;
